import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';
import { NS } from '@/constants';

const QuickMenu = dynamic(() => import('@/components/categ/QuickMenu'));
QuickMenu.displayName = 'QuickMenu';
const TopCategory = dynamic(() => import('@/components/categ/TopCategory'));
TopCategory.displayName = 'TopCategory';
const DynamicLayout = dynamic(() => import('@/components/layout/DynamicLayout'));
DynamicLayout.displayName = 'DynamicLayout';
const DescriptionCard = dynamic(() => import('@/components/categ/DescriptionCard'));
DescriptionCard.displayName = 'DescriptionCard';

import styles from './CategFooter.module.scss';

const CategFooter = ({ categ, isDesktop, isMobileDevice, descriptionRef, espot }) => {
	const { t } = useTranslation([NS.COMMON, NS.CATEG]);
	const { top: topCategory } = categ;

	return (
		<>
			{categ?.categLinks?.length > 0 && (
				<div className={`mx-0 ${styles['quick-menu-container']}`}>
					<QuickMenu t={t} categLinks={categ.categLinks} isMobile={!isDesktop} />
				</div>
			)}
			{!isDesktop && topCategory?.length > 0 && (
				<div className={styles['top-category-mobile']}>
					<TopCategory t={t} isMobileDevice={true} topCategory={topCategory} numberOfLinks={topCategory?.length} />
				</div>
			)}
			{categ.footerEspots?.length > 0 && (
				<DynamicLayout
					componentList={categ.footerEspots}
					isMobileDevice={isMobileDevice}
					styles={styles}
					lazy={true}
					withAssistant={false}
				/>
			)}

			{categ.longDescription && (
				<div className="mt-4" id="categDesc" ref={descriptionRef}>
					<DescriptionCard t={t} categ={categ} />
				</div>
			)}

			{categ.htmlFooter && (
				<div data-test-id="htmlFooter" className="w-100" dangerouslySetInnerHTML={{ __html: categ.htmlFooter }} />
			)}

			{espot?.length > 0 && <div id="blogPost" className={styles.BlogPost} dangerouslySetInnerHTML={{ __html: espot }} />}
		</>
	);
};

CategFooter.propTypes = {
	categ: PropTypes.object,
	isDesktop: PropTypes.bool,
	isMobileDevice: PropTypes.bool,
	descriptionRef: PropTypes.object,
	espot: PropTypes.object,
};

export default CategFooter;
